// Order
export const ORDER_TIMES = 10

// Align
export const ALPHA = 0.1

// Compact
export const DISTANCE_IN = 30
export const DISTANCE_OUT = 20

// Render
export const TIME_UNIT = 10
export const TIME_GAP_RATIO = 0.8
export const TWIST_FACTOR = 0.1
export const BEZIER_SAMPLE_NODES = 20
export const STYLE_LABELS = [
  'Normal',
  'Color',
  'Width',
  'Dash',
  'Zigzag',
  'Wave',
  'Bump',
  'Unmerge',
  'Twine',
  'Merge',
  'Collide',
]
